import { cn } from '@/shared/lib/utils';
import React, { ButtonHTMLAttributes, forwardRef, ReactElement } from 'react';


export interface IIconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    icon: ReactElement,
    bg?: 'default' | 'empty' | 'white'
    disabled?: boolean;
}


export const IconButton = forwardRef<HTMLButtonElement, IIconButtonProps>(
    (
        {
            className,
            icon,
            bg='default',
            disabled,
            ...props
        },
        ref,
    ) => {

        const backgrounds = {
            default: '',
            white: 'bg-[var(--white-solid)]',
            empty: 'border border-[--white-solid] bg-none text-[--white-solid]',
        }

        const defaultStyles = `
            flex items-center justify-center h-11 w-11 rounded-[44px]
        `

        return (
            <button
                ref={ref}
                className={cn(
                    defaultStyles,
                    backgrounds[bg],
                    className
                )}
                {...props}
                disabled={disabled}
            >
                {icon}
            </button>
        )
    }
)

IconButton.displayName = 'IconButton'; 